import React, { useState } from 'react'
import { AsetHero1, AsetHero2 } from 'assets'
import Login from './Login.js'
import { Carousel, CarouselCaption, CarouselIndicators, CarouselItem, Col, Container, Row } from 'reactstrap'
import './auth.scss'
import BrandMark from 'components/BrandMark'
import Register from './Register.js'
import LupaPassword from './LupaPassword.js'
import BuatPassword from './BuatPassword.js'

const Layout = (props) => {
  const location = window.location.pathname
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  // `ratio` = rasio artwork masing-masing SVG (lebar/tinggi dari viewBox-nya).
  // Kotak gambar dibentuk mengikuti angka ini, sehingga artwork mengisi
  // kotaknya tepat — tidak terpotong, dan tidak menyisakan celah. Celah sekecil
  // apa pun membuat sudut artwork yang siku terlihat di dalam kotak yang
  // membulat, dan pembulatan sudutnya jadi seolah hilang.
  const items = [
    {
      id: 1,
      images: AsetHero1,
      // PG1 aslinya punya padding transparan (kiri 112px, kanan 82px, bawah
      // 105px) yang sudah dipangkas saat menyiapkan berkasnya. Rasio di sini
      // harus sama dengan rasio berkas jadinya (1400x1060), supaya artwork
      // mengisi kotak tepat — tidak terpotong, tidak menyisakan celah yang
      // membuat sudut membulatnya tidak terlihat.
      ratio: 1400 / 1060,
      header: "Kami fokus pada komposisi musik dan lirik, membantu Songwriter mengelola hak cipta mereka dan menerima royalti dari penggunaan karya mereka.",
      text: ''
    },
    {
      id: 2,
      images: AsetHero2,
      // Berkas jadinya 1400x1059; PG2 tidak perlu dipangkas.
      ratio: 1400 / 1059,
      header: "LOKA Publishing adalah perusahaan musik publisher yang membantu Songwriter untuk mengelola, melindungi, dan memaksimalkan nilai ekonomi dari karya cipta mereka.",
      text: ""
    },
  ];

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        className="custom-tag"
        tag="div"
        key={item.id}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <div
          className="hero-image-wrapper"
          style={{ "--hero-ratio": item.ratio }}
        >
          {/* Sekarang <img>, jadi pengaturan ukurannya lewat `object-fit` di
              auth.scss — bukan `preserveAspectRatio` yang hanya berlaku untuk
              inline SVG. `alt` sengaja kosong: gambar ini hiasan, dan pesannya
              sudah disampaikan teks caption di bawahnya. */}
          <img src={item.images} alt="" className="hero-image" />
        </div>
        <CarouselCaption
          captionHeader={item.header}
          captionText={item.text}
        />
      </CarouselItem>
    );
  });

  return (
    <Container fluid className='layout-container'>
      <Row>
        <Col>
          {/* Penanda merek untuk layar sempit. Di layar lebar carousel di
              sebelah sudah memuat logo LOKA, jadi lockup ini disembunyikan
              agar tidak dobel — lihat .auth-brand di auth.scss. */}
          <BrandMark className="auth-brand" />
          {props.children}
        </Col>
        <Col className='hero-container'>

          <Carousel activeIndex={activeIndex} next={next} previous={previous}>
            {slides}
            {/* Ditaruh setelah {slides}, bukan sebelumnya: indikator dikembalikan
                ke aliran normal (lihat .custom-indicators di auth.scss), jadi
                urutan DOM inilah yang menentukan posisinya — di bawah caption,
                tidak lagi menumpuk di atasnya. */}
            <CarouselIndicators
              items={items}
              className='custom-indicators'
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
            />
          </Carousel>
        </Col>
      </Row>
    </Container>
  )
}

export default Layout